import { Injectable } from '@angular/core';
import { ConfirmationService } from 'primeng/api';

export interface ModalStatusOptions {
  title: string;
  message: string;
  actionLabel?: string;
  accept?: () => void;
  key?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ModalStatusService {

  constructor(
    private readonly confirmationService: ConfirmationService,
  ) {}

  public open(options: ModalStatusOptions): void {
    this.confirmationService.confirm({
      key: options.key ?? 'status-modal',
      header: options.title,
      message: options.message,
      acceptLabel: options.actionLabel ?? 'Voltar',
      rejectVisible: false,
      closable: false,
      closeOnEscape: true,
      dismissableMask: false,
      blockScroll: true,
      accept: () => options.accept?.(),
    });
  }

  public close(): void {
    this.confirmationService.close();
  }

}
